import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Redirects to `redirectPath` if `featureKey` is not in the user's enabled features.
 * @param {string} featureKey - The feature to check (e.g. 'cud_dashboard').
 * @param {string} redirectPath - The path to navigate to if the feature is missing (e.g. '/requests').
 */
export function useAccessCheck(featureKey, redirectPath) {
  const { features } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (Array.isArray(features) && !features.includes(featureKey)) {
      console.log(`[useAccessCheck] '${featureKey}' not enabled — redirecting to ${redirectPath}`);
      navigate(redirectPath, { replace: true });
    }
  }, [features, featureKey, redirectPath, navigate]);
}
